import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var RichText = function RichText(props) {
  var _getThemeData = getThemeData(props, 'common'),
    lineColor1 = _getThemeData.lineColor1;
  return css([".c7n-pro-rich-text-wrapper{&.c7n-pro-rich-text-float-label .c7n-pro-rich-text{border:1px solid ", ";border-radius:2px;}.c7n-pro-field-label-wrapper .c7n-pro-field-label{line-height:16px;background-color:#fff;}}.ql-container.ql-snow,.ql-toolbar.ql-snow{border-color:", ";}"], lineColor1, lineColor1);
};
export default RichText;